import { render } from "./Inventory_UserSelectItem_Dialog.vue?vue&type=template&id=d256629e&scoped=true&ts=true"
import script from "./Inventory_UserSelectItem_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_UserSelectItem_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_UserSelectItem_Dialog.vue?vue&type=style&index=0&id=d256629e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d256629e"]])

export default __exports__